<div class="invalid-feedback d-block" *ngIf="control !== undefined && control.touched && control.invalid">

    <div *ngIf="control.errors?.required !== undefined; else divmaxlength">
        {{messageRequired}}
    </div>

    <ng-template #divmaxlength>
        <div *ngIf="control.errors?.maxlength; else divminlength">
            Excede el máximo de {{control.errors?.maxlength.requiredLength}} caracteres permitidos, actualmente has
            ingresado {{control.errors?.maxlength.actualLength}} caracteres.
        </div>
    </ng-template>

    <ng-template #divminlength>
        <div *ngIf="control.errors?.minlength; else divpattern">
            Ingresa al menos {{control.errors?.minlength.requiredLength}} caracteres (largo actual:
            {{control.errors?.minlength.actualLength}}).
        </div>
    </ng-template>

    <ng-template #divpattern>
        <div *ngIf="control.errors?.pattern; else divinvalidRut">
            {{messagePattern}}
        </div>
    </ng-template>

    <ng-template #divinvalidRut>
        <div *ngIf="control.errors?.invalidRut; else divinvalidSamePass">
            Rut ingresado no es válido.
        </div>
    </ng-template>

    <ng-template #divinvalidSamePass>
        <div *ngIf="control.errors?.invalidSamePass; else divinvalidSameEmail">
            Las contraseñas ingresadas no coinciden.
        </div>
    </ng-template>

    <ng-template #divinvalidSameEmail>
        <div *ngIf="control.errors?.invalidSameEmail; else divinvaliMaxDate">
            Las emails ingresados no coinciden.
        </div>
    </ng-template>

    <ng-template #divinvaliMaxDate>
        <div *ngIf="control.errors?.invalidMaxDate; else divinvaliFormatDate">
            La edad mínima para el registro es 18 años.
        </div>
    </ng-template>

    <ng-template #divinvaliFormatDate>
        <div
            *ngIf="control.errors?.invalidFormatDate || control.errors?.matDatepickerParse; else divinvalidYoutubeformat">
            Favor ingrese un formato valido. Ej: 27/05/1991
        </div>
    </ng-template>

    <ng-template #divinvalidYoutubeformat>
        <div *ngIf="control.errors?.linkyoutubeformat; else divInvalidDate">
            La URL ingresada no tiene un formato valido. Ej: https://www.youtube.com/watch?v=WszVd18m0FU
        </div>
    </ng-template>

    <ng-template #divInvalidDate>

        <div *ngIf="control.errors?.invalidDate; else divinvalidMaxWord">

            <span *ngIf="control.errors?.invalidDate?.range">Seleccione una fecha entre {{control.errors?.invalidDate.range.min | date:'dd/MM/yyyy'}} y {{control.errors?.invalidDate.range.max | date:'dd/MM/yyyy'}}.</span>
            <span *ngIf="control.errors?.invalidDate?.minyear">La edad mínima para el registro es {{control.errors?.invalidDate.minyear.min}} años.</span>
            <span *ngIf="control.errors?.invalidDate?.maxyear">La edad máxima para el registro es {{control.errors?.invalidDate.maxyear.max}} años.</span>
            <span *ngIf="control.errors?.invalidDate?.mindate">Ingresa una fecha superior a {{control.errors?.invalidDate.mindate.min | date:'dd/MM/yyyy'}}</span>

        </div>
    </ng-template>


    <ng-template #divinvalidMaxWord>
        <div *ngIf="control.errors?.maxword; else divinvalidNoEmail">
            Excede el número de palabras permitidas.
        </div>
    </ng-template>

    <ng-template #divinvalidNoEmail>
        <div *ngIf="control.errors?.invalidNoEmail; else divinvalidNoEmailAt">
            No está permitido agregar direcciones de correo electrónico.
        </div>
    </ng-template>

    <ng-template #divinvalidNoEmailAt>
        <div *ngIf="control.errors?.invalidNoEmailAt; else divinvalidNoUrl">
            No está permitido ingresar correos electrónicos ni el símbolo "@".
        </div>
    </ng-template>


    <ng-template #divinvalidNoUrl>
        <div *ngIf="control.errors?.invalidNoUrl; else divinvalidMinNumber">
            No está permitido links.
        </div>
    </ng-template>

    <ng-template #divinvalidMinNumber>
        <div *ngIf="control.errors?.min; else divinvalidaMaxNumber">
            Favor ingresa un número mayor a {{control.errors?.min?.min - 1}}
        </div>
    </ng-template>

    <ng-template #divinvalidaMaxNumber>
        <div *ngIf="control.errors?.max; else divinvalidMap">
            Ingresa un valor permitido.
        </div>
    </ng-template>


    <ng-template #divinvalidMap>
        <div *ngIf="control.errors?.invalidMap; else divInvalidArrayGreaterThanZero">
            <span *ngIf="control.errors?.invalidMap?.notFound">No hemos podido encontrar la dirección ingresada.</span>
            <span *ngIf="control.errors?.invalidMap?.incomplete">La dirección ingresada se encuentra incompleta.</span>
            <span *ngIf="control.errors?.invalidMap?.noNumber">Debes ingresar el número de la dirección.</span>

        </div>
    </ng-template>
    <ng-template #divInvalidArrayGreaterThanZero>
        <div *ngIf="control.errors?.invalidGreaterThanZero; else divInvalidDifferenceLimit">
            {{messageGreaterThanZero}}
        </div>
    </ng-template>
    <ng-template #divInvalidDifferenceLimit>
        <div *ngIf="control.errors?.differenceExceedsLimit; else divInvalidCustomFn">
            {{messageDifferenceLimit}}
        </div>
    </ng-template>

    
    <ng-template #divInvalidCustomFn>
        <div *ngIf="control.errors?.customFn; else divInvalidAtLeastOneGroupLevel">
            {{messageCustomFn}}
        </div>
    </ng-template>

    <ng-template #divInvalidAtLeastOneGroupLevel>
        <div *ngIf="control.errors?.atLeastOneRequired; else nextTemplate">
            Selecciona al menos una opción.
        </div>
    </ng-template>
    <ng-template #nextTemplate>

    </ng-template>
</div>